export interface IupTemplateUnit {
  name: string;
  bedrooms: number;
  bathrooms: number;
  parking: number;
  level: number;
  price: number;
  land_area: number;
  construction_area: number;
  currency: string;
  half_bathrooms: number;
}

export interface IupTemplateBuilding {
  name: string;
  date: string;
  units: (string | number)[][];
}

export interface IBuildingFromTemplateAdapter {
  nameBuilding: string;
  deliveryDate: Date;
  units: IupTemplateUnit[];
}

export enum ETypeTemplate {
  land = "land",
  industrialSite = "industrialSite",
  house = "house",
  comercialLocals = "comercialLocals",
  apartment = "apartment",
  invalid = "invalid"
}

export const templateHeaderMapping = {
  land: "Nombre de conjunto,Fecha de entrega,Nombre unidad,Metros solar,Tipo moneda,Precio venta",
  industrialSite:
    "Nombre de conjunto,Fecha de entrega,Nombre unidad,Cantidad habitacion,Cantidad banos,Cantidad medios banos,Cantidad de parqueos,Metros solar,Metros construccion,Tipo moneda,Precio venta",
  house:
    "Nombre de conjunto,Fecha de entrega,Nombre unidad,Cantidad habitacion,Cantidad banos,Cantidad medios banos,Cantidad de parqueos,Metros solar,Metros construccion,Tipo moneda,Precio venta",
  comercialLocals:
    "Nombre de conjunto,Fecha de entrega,Nombre unidad,Cantidad banos,Cantidad medios banos,Cantidad de parqueos,Nivel,Metros solar,Metros construccion,Tipo moneda,Precio venta",
  apartment:
    "Nombre de conjunto,Fecha de entrega,Nombre unidad,Cantidad habitacion,Cantidad banos,Cantidad medios banos,Cantidad de parqueos,Nivel,Metros solar,Metros construccion,Tipo moneda,Precio venta"
};
